<template>
    <div style="text-align: center;line-height: 2.2;">
        <div style="margin-top: 20%;color: #666;">
            https://open-auth.rich-healthcare.com/login?appid=YOURAPPID&response_type=code&redirect_uri=YOURREDIRECTURI
        </div>
        <h1 style="width: 100%;">参数值：{{ code }}</h1>
        <el-input v-model="returnAddress" style="width: 500px;" placeholder="请输入回调地址" /><br>
        <el-button type="primary" size="large" style="margin-top: 20px;" @click="onSubmit">重置提交</el-button>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { reactive, ref, onMounted, nextTick, computed } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import service from "@/http/request.js";

const router = useRouter();
const returnAddress = ref(null)
const healthOrg = ref("ruici")
const code = computed(() => {
    return router.currentRoute.value.query.code;
});

const onSubmit = () => {
    if (!code.value) {
        ElMessage.error('未获取到参数值')
    }
    if (!returnAddress.value) {
        ElMessage.error('请输入回调地址')
    }
    console.log(code.value, returnAddress.value, healthOrg.value);
    ElMessageBox.confirm("请确认是否重置登录信息？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
    }).then(() => {
        service.get('/health/rich/aws/getToken', {
            params: {
                code: code.value,
                redirectUrl: returnAddress.value,
                healthOrg: "rich",
            }
        }).then(data => {
            console.log(data)
            ElMessage({
                message: "登录信息重置成功",
                type: "success",
            });
        }).catch(err => {
            ElMessage({
                message: err.message,
                type: "error",
            });
        })
    })
};

</script>